<script lang="ts">
  import type { RegionOp } from '../depth/brush';
  import { t } from '../i18n/index.svelte';

  let {
    enabled = $bindable(),
    hasMask,
    busy,
    points,
    onapply,
    onclear,
  }: {
    enabled: boolean;
    hasMask: boolean;
    busy: boolean;
    points: number;
    onapply: (op: RegionOp) => void;
    onclear: () => void;
  } = $props();

  let amount = $state(0.15);
  let angle = $state(90);
</script>

<div class="seg-tools row">
  <button
    class:active={enabled}
    onclick={() => (enabled = !enabled)}
    title={t('segment.hint')}
    data-testid="segment-toggle">✂ {t('segment.title')}</button
  >
  {#if enabled}
    {#if busy}
      <span class="muted small">{t('segment.working')}</span>
    {:else if !hasMask}
      <span class="muted small">{t('segment.clickHint')}</span>
    {:else}
      <span class="muted small">{t('segment.points', { n: points })}</span>
      <button onclick={() => onapply({ kind: 'flat' })} data-testid="segment-flat">{t('segment.flat')}</button>
      <button onclick={() => onapply({ kind: 'offset', amount })} data-testid="segment-raise">{t('brush.raise')}</button
      >
      <button onclick={() => onapply({ kind: 'offset', amount: -amount })}>{t('brush.lower')}</button>
      <button onclick={() => onapply({ kind: 'tilt', amount, angle })} title={t('segment.tiltHint')}
        >{t('segment.tilt')}</button
      >
      <label class="mini" title={t('segment.amount')}
        >Δ <input type="range" min="0.02" max="0.5" step="0.01" bind:value={amount} /></label
      >
      <label class="mini" title={t('segment.angle')}
        >∠ <input type="range" min="0" max="360" step="15" bind:value={angle} /></label
      >
      <button onclick={onclear} title={t('segment.clear')}>✕</button>
    {/if}
  {/if}
</div>

<style>
  .seg-tools {
    gap: 6px;
    flex-wrap: wrap;
  }
  .active {
    border-color: var(--accent);
    color: var(--accent);
  }
  .mini {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: var(--muted);
  }
  .mini input {
    width: 70px;
  }
  .small {
    font-size: 12px;
  }
  button {
    font-size: 12px;
    padding: 4px 8px;
  }
</style>
